import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';
import {executionLineService} from '@store/invoices/executionLines/executionLine.service';
import {ExecutionLinesState} from '@store/invoices/executionLines/executionLine.store';

export type SearchExecutionLinesParams = Partial<ExecutionLinesState>

export const searchExecutionLinesEffect = createEffectFn((params$: Observable<SearchExecutionLinesParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => executionLineService.getExecutionLines().pipe(catchError(() => EMPTY))),
  );
});
